import axiosInstance from "../utils/axios";

export const GetAppealsCommonComponent = async () => {
  return await axiosInstance().get("/getAppealCommonContent");
};

export const ViewAppeal = async (data) => {
  return await axiosInstance().get(`/viewAppeal`, { params: data });
};

export const ApproveOrDeclineAppeal = async (data) => {
  return await axiosInstance().post("/approveOrDeclineAppeal", data);
};

export const GetStudentAppealAuditTrail = async (data) => {
  return await axiosInstance().post("/getStudentAppealAuditTrail", data);
};
